var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      opacity: 0.32,
      fill: "none",
      stroke: "#6d6e71",
      strokeWidth: 0.284,
      strokeMiterlimit: 10
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h512v512h-512z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m74.98 74.98h362.04v362.04h-362.04z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m128 0h256v512h-256z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m256 0v512"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 128h512v256h-512z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0 256h512"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m512 0-512 512"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 512 512"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 181.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 128
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m403.04 512h-294.07c-17.93 0-31.86-15.63-29.81-33.44l12.22-105.97c1.4-12.1 9.3-22.47 20.59-27.03l98.31-39.72c3.96-1.6 8.19-2.42 12.46-2.42h66.52c4.27 0 8.51.82 12.47 2.42l98.3 39.72c11.3 4.56 19.2 14.93 20.59 27.03l12.22 105.97c2.05 17.81-11.87 33.44-29.8 33.44z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m403.04 512h-294.07c-17.93 0-31.86-15.63-29.81-33.44l12.22-105.97c1.4-12.1 9.3-22.47 20.59-27.03l80.65-32.59c10.22 30.9 39.1 113.96 59.12 129.35 21.32 16.4 58.43-97.66 68.18-129.13l80.11 32.37c11.3 4.56 19.2 14.93 20.59 27.03l12.22 105.97c2.05 17.81-11.87 33.44-29.8 33.44z",
    fill: "#393d63"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m291.42 280.89-.32.19c-20.42 12.36-45.92 12.75-66.71 1.02l-.25-.14c-1.87-1.06-3.71-2.16-5.51-3.31v80.68h74.75v-79.67c-.66.42-1.31.83-1.96 1.23z",
    fill: "#eeab90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.54 388.34c-.46.69-.69 1.5-.55 2.31l.36 2.19 2.13 38.49 1.92 34.63-7.16 8.19c-1.12 1.29-2.68 1.93-4.24 1.93s-3.12-.64-4.24-1.93l-7.93-9.07c.75-11.23 1.51-22.75 2.19-33.19 1.41-21.59 2.49-38.53 2.49-38.53l.41-2.01c.2-1.05-.08-2.11-.67-3.01 0 0 0 0 0-.01l-4.58-10.13c-2.67-2.54-2.65-6.46.07-8.96l5.58-5.14c3.65-3.38 9.73-3.54 13.62-.37l5.45 5.4c2.52 2.51 2.5 6.28-.07 8.75l-4.78 10.45z",
    fill: "#f2614e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.11 359.38-20.56 12.48 15.42 19.09-65.57 75.01-7.16 8.19c-1.12 1.29-2.68 1.93-4.24 1.93s-3.12-.64-4.24-1.93l-7.93-9.07-64.8-74.13 15.42-19.09-20.56-12.48s-8.85-46.99 44.74-58c0 0 2.35 70.3 27.39 130.51 2.38 5.74 4.94 11.38 7.7 16.86.75 1.49 2.86 1.5 3.62.02 2.92-5.67 5.63-11.5 8.14-17.44 25.47-60.09 27.89-129.95 27.89-129.95 53.59 11.01 44.74 58 44.74 58z",
    fill: "#515987"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m229.01 376.93 20.2-17.35.51.27c4.03 2.16 8.88 2.14 12.89-.06l.25-.14 19.87 17.07c7.26-31.65 9.64-59.19 10.35-70.21-2.97 23.68-28.8 48.98-31.52 51.58l-.9.32c-2.9 1.03-6.07 1.04-8.98.03l-1.42-.49c-3.46-3.34-28.55-28.25-31.39-51.56.7 10.96 3.01 38.69 10.14 70.54z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m164.7 178.05s-8.22-41.39-8.22-79.36 14.11-98.69 92.2-98.69c0 0 33.6.31 55.59 8.68 13.65 5.19 30.35 2.52 38.92.53 2.8-.65 5.43 1.6 5.23 4.47-.73 10.45-4.19 24.91-.77 34.89 2.28 6.66 7.87 25.19 7.87 49.6s-6.2 80.69-6.2 80.69-6.94-35.1-18.75-51.4c-7.15-9.87-8.37-23.74-8.53-30.2-.04-1.74-1.75-2.95-3.41-2.42-15.2 4.92-77.91 22.81-127.39 1.05-1.61-.71-3.44.34-3.64 2.09-.8 6.9-3.12 22.09-8.86 31.1-7.06 11.05-14.85 39.48-14.04 48.97z",
    fill: "#4f3b30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.44 158.98c0-5.3-6.76-5.95-12.56-5.54-1.35 14.39-2.57 25.41-2.57 25.41s-6.94-35.1-18.75-51.4c-7.15-9.87-8.37-23.74-8.53-30.2-.04-1.74-1.75-2.95-3.41-2.42-15.2 4.92-77.91 22.81-127.39 1.05-1.61-.71-3.44.34-3.64 2.09-.8 6.9-3.12 22.09-8.86 31.1-7.05 11.06-14.83 39.5-14.02 48.99 0 0-1.97-9.95-3.99-24.57-5.92-.5-13.16.01-13.16 5.49 0 9.04-2.93 31.3 16.41 39.28 6.71 35.03 28.48 65.83 60.17 83.7l.25.14c20.79 11.73 46.29 11.33 66.71-1.02l.32-.19c30.34-18.36 50.89-48.7 57.13-82.84 18.77-8.16 15.89-30.11 15.89-39.07z",
    fill: "#f8ccb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeMan);
export default __webpack_public_path__ + "static/media/office-man.d33ad8e04454d86e4fba094db326b303.svg";
export { ForwardRef as ReactComponent };